// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Roles Page Styles */
.roles-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.roles-header {
  padding: 1.5rem;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}

.roles-content {
  flex: 1;
  overflow: auto;
  padding: 1.5rem;
  background-color: #f9fafb;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Users/Roles/Roles.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B","sourcesContent":["/* Roles Page Styles */\n.roles-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.roles-header {\n  padding: 1.5rem;\n  background-color: #ffffff;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.roles-content {\n  flex: 1;\n  overflow: auto;\n  padding: 1.5rem;\n  background-color: #f9fafb;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
